import SHEnumCheckbox from './src/checkbox.vue';

/* istanbul ignore next */
SHEnumCheckbox.install = function(Vue) {
  Vue.component('sh-enum-checkbox', SHEnumCheckbox);
};

export default SHEnumCheckbox;



// WEBPACK FOOTER //
// ./src/components/base/view/Enum/cmps/checkbox/index.js